import { Directive, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'h8',
})
export class H8Directive {
  constructor(el: ElementRef) {}
}
